
    import useVuelidate from '@vuelidate/core'
    import { required, email } from '@vuelidate/validators'

    const mustBePhoneNumber = (value) => {
        const val = value.replaceAll(' ', '');
        return /^([0-9]{10,})$/.test(val);
    }

    export default {
        head() {
            let metaValue = [];
            try {
                if ( this.landingInfo?.attributes?.meta != null && 
                    this.landingInfo?.attributes?.meta != undefined  && 
                    Array.isArray(JSON.parse(this.landingInfo?.attributes?.meta.replace('\n', ''))))

                    { metaValue = JSON.parse(this.landingInfo?.attributes?.meta.replace('\n', '')); }
            } catch (e) {
            }
            
            return {
                title: `${this.landingInfo?.attributes?.metaTitle}`,
                meta: metaValue
            };
        },
        data() {
            const isOpen = false;
            const dublon = false;
            let formSent = false;
            let sending = false;

            let landingForm = {
                prenom: '',
                nom: '',
                email: '',
                telephone: '',
                codePostal: '',
                anneeDuBac: '',
                bac: '',
                consent: '',
            };

            return {
                landingForm,
                formSent,
                sending,
                isOpen,
                dublon,
                isMounted: false,
            }
        },

        mounted() {
            this.isMounted = true;
        },

        setup() {
            return { v$: useVuelidate() }
        },

        validations() {
            return {
                landingForm: {
                    prenom: { required },
                    nom: { required },
                    email: { required, email },
                    telephone: { required, mustBePhoneNumber },
                    codePostal: { required },
                    anneeDuBac: { required },
                    bac: { required },
                    consent: { required },
                }

        }
        },
        methods: {
            checkLandingForm() {
            },
            async sendStudent() {
                try{
                    if (await this.v$.$validate()) {
                        this.sending = true;
                        this.landingForm.landingName = this.params.landing;
                        this.landingForm.idDiploma = this.landingInfo?.attributes?.diploma?.data?.attributes?.idDiplomeCRM;
                        this.landingForm.idSession = this.landingInfo?.attributes?.session?.data?.attributes?.idSessionCRM;
                        this.landingForm.utm = JSON.stringify(this.$store.state.utm);

                        // send url, diplomq ID and prefix of campus
                        this.landingForm.campusDiplomaId = this.landingInfo?.attributes?.diploma?.data?.id;
                        this.landingForm.url = window.location.host + "" + this.$nuxt.$route.path;
                        this.landingForm.campusPrefix = this.instance.attributes.prefix;

                        let formData = new FormData();
                        formData.append('data', JSON.stringify(this.landingForm));
                        let result = await this.$http.$post(`${process.env.apiCrmServer}candidature_landing.php?`, formData);

                        if (result == "success") {
                            this.formSent = true;
                        }  else if(result.code == 'alreadyExist'){
                            // display popup
                            this.sending = false;
                            this.dublon = true;
                            this.isOpen = true;
                        }
                        else {
                            this.sending = false;
                            this.isOpen = true
                        }
                    }
                }catch(error){
                    this.sending = false;
                    this.isOpen = true
                }
            },
            scrollToForm() {
                const element = document.getElementById("postuleHeader");
                element.scrollIntoView({ behavior: 'smooth' });
            },
        },
        
        async asyncData({ params, $http, store, redirect }) {
            let instances = store.state.instances;

            const instance = instances.filter((instance) => {
                return instance.attributes.subFolderName == params.campusHP
            })[0];

            if(!instance){
                // redirect to lost page
                redirect('/404-error/')
            }
            let detailInfo = store.state.detailInfo;

            let landingInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-landings?filters[title][$eq]
            =${params.landing}&populate=arrierePlanPremierEcran,arrierePlanPremierEcranMobile,avantageImage1TroisiemeEcran,avantageImage2TroisiemeEcran,
            avantageImage3TroisiemeEcran,temoinageImage1CinquiemeEcran,avisEtudiantsQuatriemeEcran,entreprisesAccueilQuatriemeEcran,
            temoinageImage1CinquiemeEcran,temoinageImage2CinquiemeEcran,imageGrandeSixiemeEcran,diploma,session`);
            landingInfo = landingInfo.data[0];

            if (!landingInfo) {
                // redirect to lost page
                redirect('/404-error/')
            }

            let arrierePlanPremierEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.arrierePlanPremierEcran?.data?.attributes?.url;
            let arrierePlanPremierEcranMobileUrl = process.env.strapiBaseUri + landingInfo.attributes.arrierePlanPremierEcranMobile?.data?.attributes?.url;
            let avantageImage1TroisiemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.avantageImage1TroisiemeEcran?.data?.attributes?.url;
            let avantageImage2TroisiemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.avantageImage2TroisiemeEcran?.data?.attributes?.url;
            let avantageImage3TroisiemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.avantageImage3TroisiemeEcran?.data?.attributes?.url;
            let avisEtudiantsQuatriemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.avisEtudiantsQuatriemeEcran?.data?.attributes?.url;
            let entreprisesAccueilQuatriemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.entreprisesAccueilQuatriemeEcran?.data?.attributes?.url;
            let temoinageImage1CinquiemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.temoinageImage1CinquiemeEcran?.data?.attributes?.url;
            let temoinageImage2CinquiemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.temoinageImage2CinquiemeEcran?.data?.attributes?.url;
            let imageGrandeSixiemeEcranUrl = process.env.strapiBaseUri + landingInfo.attributes.imageGrandeSixiemeEcran?.data?.attributes?.url;
            let youtubeVideo = landingInfo.attributes?.youtubeVideo
            if (youtubeVideo) {
                const urlObj = new URL(youtubeVideo);
                youtubeVideo = urlObj.searchParams.get("v");
            }
            
            return {
                params, instances, instance,detailInfo,landingInfo,arrierePlanPremierEcranUrl,arrierePlanPremierEcranMobileUrl,
                avantageImage1TroisiemeEcranUrl,avantageImage2TroisiemeEcranUrl,avantageImage3TroisiemeEcranUrl,avisEtudiantsQuatriemeEcranUrl,
                entreprisesAccueilQuatriemeEcranUrl,temoinageImage1CinquiemeEcranUrl,temoinageImage2CinquiemeEcranUrl,imageGrandeSixiemeEcranUrl,
                youtubeVideo
            }
        },
    }
